import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-between align-items-center" }



  //  Components
  import Price from '@/components/common/Price.vue'
  // Props
  interface Props {
    title: string
    price: number
    textClass?: string
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BaseTotal',
  props: {
    title: {},
    price: {},
    textClass: {}
  },
  setup(__props: any) {

  // Vue
  const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", {
      class: _normalizeClass(["body text-grey-700 m-0", _ctx.textClass])
    }, _toDisplayString(_ctx.title), 3),
    _createElementVNode("p", {
      class: _normalizeClass(["body text-grey-900 m-0", _ctx.textClass])
    }, [
      _createVNode(Price, { price: _ctx.price }, null, 8, ["price"])
    ], 2)
  ]))
}
}

})